/* *************************
 * 	hover actions
 * ************************* */
var hoverActions = {
	init:function(){
	    $('.hover-add-class').mouseenter(function(e) {
	    	var target = $(e.currentTarget);
	    	var css_selector = target.data('hv-selector');
	    	var css_class = target.data('hv-class');
	    	if (typeof(css_selector) == 'undefined' || css_selector == '') css_selector = e.currentTarget;
	    	$(css_selector).addClass(css_class);
	    }).mouseleave(function(e) {
	    	var target = $(e.currentTarget);
	    	var css_selector = target.data('hv-selector');
	    	var css_class = target.data('hv-class');
	    	if (typeof(css_selector) == 'undefined' || css_selector == '') css_selector = e.currentTarget;
	    	$(css_selector).removeClass(css_class);
	    });
	}
};

$(document).ready(function() {
	hoverActions.init();
});

/* *******************
 * Comfortcontact
 * ****************** */
function showComfortcontact(){
	$('.comfortcontact-box').addClass('show-box');
	$('BODY').addClass('comfortcontact-open');
}
function hideComfortcontact(){
	$('.comfortcontact-box').removeClass('show-box');
	$('BODY').removeClass('comfortcontact-open');
}

$(document).ready(function () {
	$( ".btn-comfortcontact" ).hover(
	      function() {
	    	showComfortcontact();
	      },
	      function() {
	      	$(document).on("mouseleave",'.comfortcontact-box, .btn-comfortcontact', function () { 
	      		if($(".comfortcontact-box:hover").length != 0) return;
				hideComfortcontact();
	      		$(document).off('mouseleave', '.comfortcontact-box, .btn-comfortcontact');
			});
	      }
	);
	$( ".btn-comfortcontact" ).click(function() {
		showComfortcontact(this);
		$(document).on("mouseup.hideDocClick", function () { hideComfortcontact();$(document).off('.hideDocClick'); });
	});
});

/* *************************
 * 	nav
 * ************************* */
window.nav = {
	menuContainerId : 'main-menu',
	navbarNavSelector : '#mainnav .navbar-nav',
	dropdown : $("#mainnav .navbar-nav > .dropdown"),
	dropdownDropdown : $("#mainnav .navbar-nav .dropdown .dropdown > .dropdown-item"),
	dropdownToggle : $(".dropdown-toggle"),
	dropdownMenu : $(".dropdown-menu"),
	showClass : "show",
	navMobiledDdClass : '.mobile-dd-toggle',
	navMobileBreakpoint:0,
	init:function(){
		/*
		nav.dropdown.hover(
	      function() {
			if ($(window).width() > nav.navMobileBreakpoint) nav.openHoverMenu(this);
	      },
	      function() {
	  		if ($(window).width() > nav.navMobileBreakpoint) nav.closeHoverMenu();
	      }
	    );
	    $(nav.navbarNavSelector + ' .nav-link, ' + nav.navbarNavSelector + ' .dropdown-item').on('click', function() {
	        $('#' + nav.menuContainerId).collapse('hide');
	    });
		*/
		/* mobile-dd-toggle */
		/* mobile-dd-toggle */
		if (nav.navMobiledDdClass != '') {
			$("#mainnav " + nav.navMobiledDdClass).click(nav.switchMobileDdToggle);
	        $("#mainnav " + nav.navMobiledDdClass).keydown(function(e) {
		        if (e.key === "Enter") nav.switchMobileDdToggle(e);
	        });
		}
	},
	switchMobileDdToggle:function(e) {
			if ($(e.currentTarget).attr("aria-expanded") == 'false') {
		        nav.openMenu($(e.currentTarget).closest('.dropdown'));
			} else {
		        nav.closeMenu($(e.currentTarget).closest('.dropdown'));
			}
	    	e.stopPropagation();
	        e.preventDefault();
	},
	openMenu:function(e){
		var $this = $(e);
	    $this.addClass(nav.showClass);
	    $this.children(nav.dropdownToggle).attr("aria-expanded", "true");
	    $this.children(nav.dropdownMenu).addClass(nav.showClass);
		$this.children(nav.dropdownToggle).children(nav.navMobiledDdClass).attr("aria-expanded", "true");
	},
	closeMenu:function(e){
		if (e) {
	    	var $this = e;			
		} else {
	    	var $this = $(nav.dropdown);
		}
        $this.removeClass(nav.showClass);
        $this.children(nav.dropdownToggle).attr("aria-expanded", "false");
        $this.children(nav.dropdownMenu).removeClass(nav.showClass);

		$this.find(nav.navMobiledDdClass).first().attr("aria-expanded", "false");
			
	},
	openHoverMenu:function(e){
		nav.closeHoverMenu();
		nav.openMenu(e);
		nav.dropdown.click(
	      function(e) {
                nav.closeHoverMenu();
		});
	},
	closeHoverMenu:function(e){
		nav.closeMenu(nav.dropdown);			
	},
};

// SwitchHeader — Einfacher Wechsel von Header-Zuständen beim Scrollen
// Nutzung:
// 1) Ziel-Element anlegen, z. B. <div id="switchheader"></div>
// 2) Modul initialisieren:
//    switchHeader.init({
//      selector: '#switchheader',
//		switchPosition:'300',
//      before: () => document.querySelector('.header-bgcontainer').classList.add('bg-secondary'),
//      after:  () => document.querySelector('.header-bgcontainer').classList.remove('bg-secondary'),
//      debounceMs: 60 // optional, Standard: 80
//		offset: -0
//    });
//    - before wird ausgeführt, wenn das Fenster die Position des Elements erreicht oder überschreitet.
//    - after wird ausgeführt, wenn das Fenster wieder oberhalb der Position ist.
//    - Existiert das Element nicht, wird before sofort ausgeführt (wie im Original).
// 3) Optionale Methoden:
//    switchHeader.trigger()           // manueller Check
//    switchHeader.setSelector('#id')  // Selector ändern

window.switchHeader = (function () {
  const noop = () => {};

  function debounce(fn, wait = 0) {
    let t = null;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  let selector = '#switchheader';
  let onBefore = noop;
  let onAfter = noop;
  let lastState = null;
  let element = null;
  let switchPosition = null;
  let offset = 0; // Neuer Parameter
 
  function updateElement() {
    element = document.querySelector(selector);
  }

  function getOffsetTop(el) {
    if (!el) return null;
    const rect = el.getBoundingClientRect();
    return rect.top + window.pageYOffset;
  }

  function check() {
    // 1. Position ermitteln: Element hat Vorrang vor switchPosition
    let basePosition = 0;
    const elTop = getOffsetTop(element);

    if (elTop !== null) {
      basePosition = elTop;
    } else if (switchPosition !== null) {
      basePosition = switchPosition;
    }

    // 2. Offset dazurechnen
    const threshold = basePosition + offset;
    const scrolledPast = window.pageYOffset >= threshold;

    if (scrolledPast === lastState) return;
    lastState = scrolledPast;

    // Falls gescrollt (true) -> After, sonst -> Before
    if (scrolledPast) onAfter();
    else onBefore();
  }

  return {
    init({ 
      selector: sel = '#switchheader', 
      before = noop, 
      after = noop, 
      debounceMs = 80, 
      switchPosition: pos = null,
      offset: off = 0 // Neuer Parameter in init
    } = {}) {
      selector = sel;
      onBefore = typeof before === 'function' ? before : noop;
      onAfter = typeof after === 'function' ? after : noop;
      
      // Sicherstellen, dass Werte Zahlen sind
      switchPosition = pos !== null ? Number(pos) : null;
      offset = Number(off);
      
      updateElement();

      // Falls weder Element noch feste Position existieren, abbrechen
      if (!element && switchPosition === null) return;

      check();
      const handler = debounce(check, debounceMs);
      window.addEventListener('scroll', handler, { passive: true });
      window.addEventListener('resize', () => {
        updateElement();
        handler();
      }, { passive: true });
    },
    trigger() { check(); },
    setSelector(sel) { selector = sel; updateElement(); check(); }
  };
})();

/**
 * SmoothScrollHandler
 * 
 * Verwendung:
 * const scrollHandler = new SmoothScrollHandler({ 
 *    offset: 140,            // Standard Offset für normale Anker
 *    accordionOffset: 100,   // Spezieller Offset für Accordion-Elemente
 *    speed: 600              // Animationsgeschwindigkeit in ms
 * });
 * 
 * Voraussetzung: jQuery und Bootstrap JS müssen geladen sein.
 */
class BootstrapScrollHandler {
    constructor(options = {}) {
        // Zwei verschiedene Offsets konfigurierbar
        this.defaultOffset = options.offset || 140;
        this.accordionOffset = options.accordionOffset || 90; 
        this.speed = options.speed || 600;
        
        // CSS Smooth Scroll deaktivieren für volle JS-Kontrolle
        $('html').css('scroll-behavior', 'auto !important');
        
        this.init();
    }

    init() {
        // 1. Initialer Check (Deep Link)
        $(window).on('load', () => {
            if (window.location.hash) {
                window.scrollTo(0, 0); 
                setTimeout(() => this.handleTarget(window.location.hash), 100);
            }
        });

        // 2. Klick-Handler
        $(document).on('click', 'a[href*="#"]', (e) => {
            const link = e.currentTarget;
            if (link.pathname === window.location.pathname && link.hash) {
                e.preventDefault();
                e.stopImmediatePropagation();
                
                this.handleTarget(link.hash);
                history.pushState(null, null, link.hash);
            }
        });
    }

    handleTarget(hash) {
        const $target = $(hash);
        if (!$target.length) return;

        // Fallunterscheidung: Accordion vs. normaler Anker
        const isAccordion = $target.hasClass('collapse') || $target.hasClass('accordion-collapse');
        const currentOffset = isAccordion ? this.accordionOffset : this.defaultOffset;

        if (isAccordion) {
            if ($target.hasClass('show')) {
                this.scrollToElement($target, currentOffset);
            } else {
                // Erst scrollen, wenn Bootstrap fertig ausgeklappt hat (verhindert Ruckeln)
                $target.one('shown.bs.collapse', () => {
                    this.scrollToElement($target, currentOffset);
                });
                $target.collapse('show');
            }
        } else {
            this.scrollToElement($target, currentOffset);
        }
    }

    scrollToElement($element, offsetValue) {
        // Position erst bei Funktionsaufruf messen (wichtig nach dem Aufklappen!)
        const targetPos = $element.offset().top - offsetValue;

        $('html, body').stop(true).animate({
            scrollTop: targetPos
        }, this.speed, 'swing');
    }
}
window.BootstrapScrollHandler = BootstrapScrollHandler;